import { extractHighlightedUsers, sortByPortfolio } from "../../services/profesionalesService.ts";

type RootState = {
  general?: {
    usersRegisteredData?: any[];
  };
  register?: {
    usersBySkill?: any[];
    itemCount?: number;
    page?: number;
    skillsList?: any[];
  };
  profile?: {
    usersInJurisdiction?: any[];
  };
};

export const selectRegisteredUsers = (state: RootState) =>
  state.general?.usersRegisteredData ?? [];

export const selectSkillsList = (state: RootState) => state.register?.skillsList ?? [];

export const selectJurisdictions = (state: RootState) =>
  state.profile?.usersInJurisdiction ?? [];

export const selectFilteredUsers = (state: RootState) =>
  state.register?.usersBySkill ?? [];

export const selectFilteredMeta = (() => {
  let lastItemCount = 0;
  let lastPage = 1;
  let lastResult = { itemCount: 0, page: 1 };

  return (state: RootState) => {
    const registerState: any = state.register ?? {};
    const itemCount = registerState?.itemCount ?? 0;
    const page = registerState?.page ?? 1;

    if (itemCount !== lastItemCount || page !== lastPage) {
      lastItemCount = itemCount;
      lastPage = page;
      lastResult = { itemCount, page };
    }

    return lastResult;
  };
})();

export const selectHighlightedProfessionals = (state: RootState, take = 12) => {
  const users = selectRegisteredUsers(state);
  return extractHighlightedUsers(users, take);
};

export const selectRegisteredSortedByPortfolio = (state: RootState) => {
  const users = selectRegisteredUsers(state);
  return sortByPortfolio(users);
};

